import React from "react";
import serviceInvoiceData from "../data/serviceInvoiceData";

const ServiceTemplate = () => {
  const data = serviceInvoiceData;
  const invoice = data || {
    invoiceNumber: "INV-2026-001",
    invoiceDate: "15 Jan 2026",
    balanceDue: "₹18,400.00",
    clientName: "Rohit Sharma",
    clientAddress: "Flat 502, Green Park Apartments, Sector 14, Noida, Uttar Pradesh, 201301",
    items: [
      { id: 1, desc: "Brochure Design", subDesc: "Single sided (Color)", qty: 1, rate: 900, amount: 900 },
      { id: 2, desc: "Website Design Package", subDesc: "10 Pages, Slider, Free Logo", qty: 1, rate: 10000, amount: 10000 },
      { id: 3, desc: "Business Cards", subDesc: "Set of 100 Cards, Full Color", qty: 2, rate: 350, amount: 700 },
    ],
    taxRate: 18, // GST %
  };

  const subtotal = invoice.items.reduce((acc, item) => acc + Number(item.amount || 0), 0);
  const tax = (subtotal * (invoice.taxRate || 0)) / 100;
  const total = subtotal + tax;

  return (
    <div className="bg-white p-6 text-gray-800 font-sans mx-auto max-w-[900px]">
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center gap-4">
          <img src='/logo1.png' alt="Logo" className="w-16 h-16 object-contain" />
          <div>
            <h1 className="text-xl font-bold text-[#A83E0C]">Zylker Design Labs</h1>
            <p className="text-sm text-gray-500 leading-tight">
              14B, Northern Street, <br />
              Greater South Avenue, <br />
              New Delhi, 110001, India
            </p>
          </div>
        </div>
        <div className="text-right">
          <h2 className="text-4xl font-bold text-[#A83E0C] uppercase tracking-tight">Invoice</h2>
          <p className="font-bold mt-1"># {invoice.invoiceNumber}</p>
          <p className="text-sm text-gray-500 mt-1">Date: {invoice.invoiceDate}</p>
          <p className="mt-2 font-semibold text-lg">Balance Due: ₹{total.toLocaleString()}</p>
        </div>
      </div>

      {/* Client Info */}
      <div className="flex justify-between mb-4 text-sm">
        <div>
          <p className="text-gray-400 font-medium mb-1">Bill To:</p>
          <p className="font-bold text-[#A83E0C]">{invoice.clientName}</p>
          <p className="text-gray-500">{invoice.clientAddress}</p>
        </div>
        <div className="text-right">
          <p className="text-gray-400 font-medium mb-1">Ship To:</p>
          <p className="text-gray-500">{invoice.clientAddress}</p>
        </div>
      </div>

      {/* Items Table */}
      <table className="w-full text-sm border-collapse mb-4">
        <thead>
          <tr className="bg-[#A83E0C] text-white text-xs uppercase">
            <th className="py-2 px-2 w-8 text-center">#</th>
            <th className="py-2 px-2 text-left">Item & Description</th>
            <th className="py-2 px-2 text-right w-20">Qty</th>
            <th className="py-2 px-2 text-right w-24">Rate (₹)</th>
            <th className="py-2 px-2 text-right w-24">Amount (₹)</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items.map((item, idx) => (
            <tr key={idx} className="border-b border-gray-200">
              <td className="py-2 px-2 text-center text-gray-500">{idx + 1}</td>
              <td className="py-2 px-2">
                <p className="font-semibold text-gray-700">{item.desc}</p>
                <p className="text-xs text-gray-400">{item.subDesc}</p>
              </td>
              <td className="py-2 px-2 text-right">{item.qty}</td>
              <td className="py-2 px-2 text-right">{item.rate.toLocaleString()}</td>
              <td className="py-2 px-2 text-right font-medium">{item.amount.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div className="flex justify-end mb-6 text-sm space-y-1 flex-col w-64 ml-auto">
        <div className="flex justify-between">
          <span>Subtotal</span>
          <span>₹{subtotal.toLocaleString()}</span>
        </div>
        <div className="flex justify-between">
          <span>GST ({invoice.taxRate}%)</span>
          <span>₹{tax.toLocaleString()}</span>
        </div>
        <div className="flex justify-between font-bold text-lg border-t pt-1">
          <span>Total</span>
          <span>₹{total.toLocaleString()}</span>
        </div>
      </div>

      {/* Notes & Terms */}
      <div className="text-xs space-y-4">
        <div>
          <p className="font-bold text-gray-600 mb-1">Notes</p>
          <p className="text-gray-500">Thank you for choosing Zylker Design Labs. Payment due within 15 days.</p>
        </div>
        <div>
          <p className="font-bold text-gray-600 mb-1">Terms & Conditions</p>
          <p className="text-gray-500">All payments must be made before the start of any design work. Late payments may incur charges.</p>
        </div>
      </div>
    </div>
  );
};

export default ServiceTemplate;
